const splitRoles = (value) => {
  if (Array.isArray(value)) {
    return value
      .flatMap((item) => String(item ?? '').split(','))
      .map((item) => item.trim())
      .filter(Boolean);
  }

  if (value == null) return [];

  return String(value)
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
};

export const getUserRoles = (user) => {
  const resolvedUser = user || {};
  const uniqueRoles = [];
  const seen = new Set();

  const pushRole = (rawRole) => {
    const normalized = String(rawRole || '').trim().toLowerCase();
    if (!normalized || seen.has(normalized)) return;
    seen.add(normalized);
    uniqueRoles.push(normalized);
  };

  splitRoles(resolvedUser.roles).forEach(pushRole);
  splitRoles(resolvedUser.role).forEach(pushRole);
  splitRoles(resolvedUser.ROL).forEach(pushRole);

  return uniqueRoles;
};

export const hasUserRole = (user, role) => {
  const expected = String(role || '').trim().toLowerCase();
  if (!expected) return false;
  return getUserRoles(user).includes(expected);
};

export const normalizeRoleSelection = (roles) => {
  const unique = [];
  const seen = new Set();

  splitRoles(roles).forEach((rawRole) => {
    const normalized = rawRole.trim();
    const key = normalized.toLowerCase();
    if (!normalized || seen.has(key)) return;
    seen.add(key);
    unique.push(normalized);
  });

  return unique;
};

export const areRoleSelectionsEqual = (leftRoles, rightRoles) => {
  const left = normalizeRoleSelection(leftRoles).map((item) => item.toLowerCase()).sort();
  const right = normalizeRoleSelection(rightRoles).map((item) => item.toLowerCase()).sort();

  if (left.length !== right.length) return false;
  return left.every((value, index) => value === right[index]);
};
